export const columnsDataCheck = [
  {
    Header: "Scénario",
    accessor: "scénario",
  },
  {
    Header: "Score",
    accessor: "score",
  },
  {
    Header: "#Managers",
    accessor: "managers",
  },

  
];

export const columnsDataAssiduity = [
  {
    Header: "Manager",
    accessor: "Manager",
  },
  {
    Header: "À jour",
    accessor: "À jour",
  },
  {
    Header: "En attente",
    accessor: "En attente",
  },
  {
    Header: "Relances",
    accessor: "Relances",
  },
  
 
];

export const columnsDataComplex = [
  {
    Header: "name",
    accessor: "name",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];
